import { render, staticRenderFns } from "./SortLi.vue?vue&type=template&id=704af224&scoped=true"
import script from "./SortLi.vue?vue&type=script&lang=js"
export * from "./SortLi.vue?vue&type=script&lang=js"
import style0 from "./SortLi.vue?vue&type=style&index=0&id=704af224&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704af224",
  null
  
)

export default component.exports